// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notifications-dropdown .ant-dropdown-menu-title-conten,
.notifications-dropdown .ant-dropdown-menu-item {
  cursor: default !important;
  padding: 0 !important;
}
.notifications-dropdown .ant-dropdown-menu {
  max-height: 70vh;
  overflow: auto;
}
.notifications-dropdown .ant-dropdown-menu-item:not(:last-of-type) {
  border-bottom: 1px solid var(--default-border-color);
  border-radius: 0px;
}`, "",{"version":3,"sources":["webpack://./src/components/functional/Notifications/Notifications.scss"],"names":[],"mappings":"AACI;;EAEI,0BAAA;EACA,qBAAA;AAAR;AAGI;EACI,gBAAA;EACA,cAAA;AADR;AAII;EACI,oDAAA;EACA,kBAAA;AAFR","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
